<template>
  <div class="contact__list-item">
    <div class="contact__card">
      <div class="dash-library__name contact-container" v-cloak>
        <div class="contact__icon">
          <span v-if="contact.hasPortalAccount" class="glyphicon glyphicon-user" aria-hidden="true"></span>
        </div>
        <div class="contact__name">
          <div class="h-bold-text">
            {{ contact.name }}<span v-if="credentials !== ''">, {{ credentials}}</span>
          </div>
          <div v-if="contact.email !== ''">Email: {{ contact.email }}</div>
          <div v-if="contact.phone_number !== ''">Phone: {{ contact.phone_number }}</div>
          <div v-if="contact.mobile !== ''">Mobile: {{ contact.mobile }}</div>
        </div>
        <div class="contact__info">
          <div class="contact__access-level">
            <Permissions v-if="contact.hasPortalAccount" :permissions="contact.portalPermissions"></Permissions>
            <span v-else>&nbsp;</span>
          </div>
          <div v-if="contact.title !== ''">Title: {{ contact.title}}</div>
          <div v-if="contact.title !== ''">Department: {{ contact.department}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Permissions from './Permissions.vue';

  export default {
    name: 'Contact',
    components: {
      Permissions,
    },
    props: {
      contact: {
        type: Object,
      },
    },
    computed: {
      credentials() {
        return this.contact.credentials.replace('credentials: ', '');
      }
    }
  }
</script>

<style scoped lang="scss">
  .contact-container {
    display:flex;
    min-height: 5.5em;
  }
  .contact {
    @include e(card) {
      color: $secondary-text;
      display: block;
      padding: em(12px);
    }

    @include e(list-item) {
      border-radius: 4px;
      border: solid 1px $alto;
      font-family: $font-family--primary;
      font-size: $base__font-size;
      color: $tundora;
      margin-bottom: em(5px);
    }
    @include e(icon) {
      flex:1;
      flex-grow:0;
      min-width: 1.5em;
    }
    @include e(name) {
      flex:1;
    }
    @include e(info) {
      flex:1;
    }
  }
</style>

